export const CLIP_UPDATE_TYPE = {
  // Segment Track
  ADD_SEGMENT_TRACK: 'ADD_SEGMENT_TRACK',
  ADD_CLIP_SEGMENTS: 'ADD_CLIP_SEGMENTS',
  REMOVE_SEGMENT_TRACK: 'REMOVE_SEGMENT_TRACK',

  // !! Currently only used to update the segment trim
  UPDATE_SEGMENT_TRACK: 'UPDATE_SEGMENT_TRACK',
  UPDATE_VIDEO_SEGMENT_TRACK: 'UPDATE_VIDEO_SEGMENT_TRACK',
  REORDER_SEGMENTS: 'REORDER_SEGMENTS',
  UPSERT_SEGMENT_TRANSITION_OUT: 'UPSERT_SEGMENT_TRANSITION_OUT',
  REMOVE_SEGMENT_TRANSITION_OUT: 'REMOVE_SEGMENT_TRANSITION_OUT',

  SPLIT_SEGMENT: 'SPLIT_SEGMENT',
  CREATE_HOOK: 'CREATE_HOOK',

  SPLIT_COMPOSITE_SEGMENT: 'SPLIT_COMPOSITE_SEGMENT',

  // Composite Segment
  ADD_COMPOSITE_SEGMENT_DELETE: 'ADD_COMPOSITE_SEGMENT_DELETE',
  REMOVE_COMPOSITE_SEGMENT_DELETE: 'REMOVE_COMPOSITE_SEGMENT_DELETE',
  UPDATE_COMPOSITE_SEGMENT_DELETE: 'UPDATE_COMPOSITE_SEGMENT_DELETE',

  BULK_ADD_COMPOSITE_SEGMENT_DELETES: 'BULK_ADD_COMPOSITE_SEGMENT_DELETES',
  BULK_PUT_COMPOSITE_SEGMENT_DELETE: 'BULK_PUT_COMPOSITE_SEGMENT_DELETE',

  ADD_COMPOSITE_SEGMENT_DELETE_WORDS: 'ADD_COMPOSITE_SEGMENT_DELETE_WORDS',

  UPDATE_COMPOSITE_SEGMENT_WORDS: 'UPDATE_COMPOSITE_SEGMENT_WORDS',
  ADD_COMPOSITE_SEGMENT_EFFECT: 'ADD_COMPOSITE_SEGMENT_EFFECT',

  // Restore Composite Segment
  RESTORE_COMPOSITE_SEGMENT_DELETE: 'RESTORE_COMPOSITE_SEGMENT_DELETE',

  // Composite Scene
  ADD_COMPOSITE_SCENE: 'ADD_COMPOSITE_SCENE',
  ADD_COMPOSITE_SCENE_RANGE: 'ADD_COMPOSITE_SCENE_RANGE',
  REMOVE_COMPOSITE_SCENE: 'REMOVE_COMPOSITE_SCENE',
  UPDATE_COMPOSITE_SCENE: 'UPDATE_COMPOSITE_SCENE',

  // Element Track
  ADD_ELEMENT_TRACK: 'ADD_ELEMENT_TRACK',
  REMOVE_ELEMENT_TRACK: 'REMOVE_ELEMENT_TRACK',
  UPDATE_ELEMENT_TRACK: 'UPDATE_ELEMENT_TRACK',
  REPLACE_ELEMENT_TRACKS: 'REPLACE_ELEMENT_TRACKS',

  // Update Scene Crop Position
  UPDATE_SCENE_CROP_POSITION: 'UPDATE_SCENE_CROP_POSITION',
  TOGGLE_VIDEO_VISIBILITY_FROM_SCENE: 'TOGGLE_VIDEO_VISIBILITY_FROM_SCENE',
  TOGGLE_VIDEO_VISIBILITY: 'TOGGLE_VIDEO_VISIBILITY',

  UPDATE_CLIP_FIT_MODE: 'UPDATE_CLIP_FIT_MODE',
  UPDATE_CLIP_BORDERS_VISIBILITY: 'UPDATE_CLIP_BORDERS_VISIBILITY',
  TOGGLE_ROUND_CORNERS: 'TOGGLE_ROUND_CORNERS',
  UPDATE_PIP_SHAPE: 'UPDATE_PIP_SHAPE',
  UPDATE_PIP_POSITION: 'UPDATE_PIP_POSITION',
  UPDATE_CLIP_SIZE: 'UPDATE_CLIP_SIZE',
  UPDATE_CLIP_SPEAKER_DIRECTION: 'UPDATE_CLIP_SPEAKER_DIRECTION',
  UPDATE_CLIP_SPEAKER_LABELS: 'UPDATE_CLIP_SPEAKER_LABELS',
  UPDATE_CLIP_SPEAKER_LABEL_STYLES: 'UPDATE_CLIP_SPEAKER_LABEL_STYLES',

  // Captions
  UPDATE_CAPTIONS_POSITION: 'UPDATE_CAPTIONS_POSITION',
  UPDATE_CAPTION_STYLES: 'UPDATE_CAPTION_STYLES',
  TOGGLE_CAPTIONS: 'TOGGLE_CAPTIONS',
  UPDATE_CAPTION_PRESET: 'UPDATE_CAPTION_PRESET',

  UPDATE_CLIP_LAYOUT: 'UPDATE_CLIP_LAYOUT',
  UPDATE_CLIP_FONT_LOCATION: 'UPDATE_CLIP_FONT_LOCATION',

  // New layouts migration
  UPDATE_NEW_LAYOUTS_MIGRATION_STATUS: 'UPDATE_NEW_LAYOUTS_MIGRATION_STATUS',

  UPDATE_WORD_HIGHLIGHT: 'UPDATE_WORD_HIGHLIGHT',
  UPDATE_VISIBLE_FACE_IDS: 'UPDATE_VISIBLE_FACE_IDS',
  UPDATE_VISIBLE_SPEAKERS: 'UPDATE_VISIBLE_SPEAKERS',
  UPDATE_VISIBLE_VIDEO_IDS: 'UPDATE_VISIBLE_VIDEO_IDS',

  UPDATE_TRACK_VISIBILITY: 'UPDATE_TRACK_VISIBILITY',

  // ! TODO: @hardik-goldcast Please remove this after susnset of older players
  UPDATE_MAGIC_LAYOUT: 'UPDATE_MAGIC_LAYOUT',

  UPSERT_ELEMENT_TRANSITION: 'UPSERT_ELEMENT_TRANSITION',

  // Transcript Editing
  EDIT_WORD: 'EDIT_WORD',
  HIDE_WORD: 'HIDE_WORD',
  SHOW_WORD: 'SHOW_WORD',
  CORRECT_ALL: 'CORRECT_ALL',
  UPDATE_PLAYER_CONFIG_METADATA: 'UPDATE_PLAYER_CONFIG_METADATA'
} as const;

/**
 * Edit types for flows that write and save the clip themselves instead of going through
 * updateClipData / updateClipDataWithSplits, so they have no CLIP_UPDATE_TYPE to report.
 * They pass these to clipVersionStore.emitEdit so the version gets the label the user
 * would expect ("Applied template" rather than the internal actions it fans out into).
 * Labels live in ./versionsDescriptionMap alongside the CLIP_UPDATE_TYPE ones.
 *
 * Kept a separate constant rather than folded into CLIP_UPDATE_TYPE above, because these
 * are not dispatchable: CLIP_UPDATE_TYPE members are the discriminants of the action union
 * in ./types, and there are two such enums anyway (the splits dispatcher defines its own
 * with different members), so this is the one list both dispatchers' flows can share.
 */
export const VERSION_EDIT_TYPE = {
  APPLY_TEMPLATE: 'APPLY_TEMPLATE',
  LANGUAGE_SWITCH: 'LANGUAGE_SWITCH',
  AI_EDIT_APPLY: 'AI_EDIT_APPLY',
  AI_QUICK_ACTION: 'AI_QUICK_ACTION',
  AI_ELEMENT_UPDATE: 'AI_ELEMENT_UPDATE',
  OVERLAY_ADD_IMAGE: 'OVERLAY_ADD_IMAGE',
  OVERLAY_ADD_VIDEO: 'OVERLAY_ADD_VIDEO',
  OVERLAY_ADD_AUDIO: 'OVERLAY_ADD_AUDIO',
  OVERLAY_UPDATE: 'OVERLAY_UPDATE',
  OVERLAY_REMOVE: 'OVERLAY_REMOVE',
  MOTION_GRAPHIC_ADD: 'MOTION_GRAPHIC_ADD',
  MOTION_GRAPHIC_UPDATE: 'MOTION_GRAPHIC_UPDATE',
  CALLOUT_CAPTION_ADD: 'CALLOUT_CAPTION_ADD',
  TEXT_UPDATE: 'TEXT_UPDATE',
  CHAPTER_ADD: 'CHAPTER_ADD',
  CHAPTER_UPDATE: 'CHAPTER_UPDATE',
  CHAPTER_REMOVE: 'CHAPTER_REMOVE'
} as const;
